<template>
  <div
    class="fixed left-0 right-0 top-0 z-[600] flex h-60 items-center justify-center bg-white shadow-[0_4px_4px_0_rgba(0,0,0,0.1)]"
  >
    <NuxtLink to="/" class="absolute left-50">
      <img src="~/assets/img/nav_bar/logo.png" class="h-32 w-60" />
    </NuxtLink>
    <div class="flex h-full w-wrap justify-center">
      <NavBarTabs />
    </div>
    <div class="absolute right-50">
      <NavBarLogin />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
